<template>
  <div class="rounded shadow-xs">
    <div class="rounded bg-white shadow-lg overflow-hidden">
      <ValidationObserver ref="observer" v-slot="{ invalid, handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="p-4 lg:p-6 bg-gray-100">
            <h3 class="text-lg">Project Owner</h3>
            <p class="text-sm text-gray-600">Change the ownership of this project</p>
          </div>
          <div class="p-4 lg:p-6 space-y-4 lg:space-y-6">
            <ValidationProvider name="member" tag="div" vid="ownerId">
              <template #default="{ errors }">
                <BaseFormGroup class="max-w-lg">
                  <BaseFormSelect
                    id="ownerId"
                    v-model="data.ownerId"
                    :options="memberOptions"
                    :disabled="isPending"
                  />
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </div>
          <div class="p-4 lg:p-6">
            <BaseButton
              :primary="isIdle || isPending"
              :success="isResolved"
              :danger="isRejected"
              :disabled="invalid"
            >
              <span v-if="isIdle">Submit</span>
              <span v-else-if="isPending">Please wait...</span>
              <span v-else-if="isResolved">Success!</span>
              <span v-else>Failed!</span>
            </BaseButton>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'ProjectOwnerForm',

  mixins: [veeValidateErrorsMixin],

  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      data: {
        ownerId: null,
      },
      status: 'idle',
    };
  },

  computed: {
    isIdle() {
      return this.status === 'idle';
    },
    isPending() {
      return this.status === 'pending';
    },
    isResolved() {
      return this.status === 'resolved';
    },
    isRejected() {
      return this.status === 'rejected';
    },
    members() {
      return this.$store.getters['ui/accountMembers/membersByAccount'](this.project.accountUuid);
    },
    memberOptions() {
      if (!Array.isArray(this.members)) {
        return [];
      }

      return this.members.map((member) => ({ value: member.id, label: member.fullName }));
    },
  },

  watch: {
    project(project) {
      this.setData(project || {});
    },
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      try {
        await this.$store.dispatch({
          type: 'ui/accountMembers/load',
          accountId: this.project.accountUuid,
        });
      } catch (error) {
        // handle error
      }

      this.setData(this.project || {});
    },
    setData({ ownerId = null }) {
      this.data.ownerId = ownerId;
    },
    async onSubmit() {
      if (!this.isIdle) {
        return;
      }
      this.setPending();
      try {
        await this.$store.dispatch({
          type: 'ui/projects/updateOwner',
          projectUuid: this.project.uuid,
          formData: this.data,
        });
        this.setResolved();
      } catch (error) {
        if (error && error.status === 422) {
          this.onUnprocessableEntityError(error.data.errors);
        }
        this.setRejected();
      } finally {
        setTimeout(() => {
          this.setIdle();
        }, 1500);
      }
    },
    setIdle() {
      this.status = 'idle';
    },
    setPending() {
      this.status = 'pending';
    },
    setResolved() {
      this.status = 'resolved';
    },
    setRejected() {
      this.status = 'rejected';
    },
    onUnprocessableEntityError(errors) {
      this.observer = this.$refs.observer;
      this.addServerErrors(errors);
    },
  },
};
</script>
